export default function () {
    return {
        publicIndex: null
    };
}
